import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import {auth} from '../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import './Home.css';
import './Auth.css'

function Signup() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSignup = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await createUserWithEmailAndPassword(auth, email, password);
        } catch (err) {
            setError("That identity has already been summoned! Try another sigil with your email");
            console.error("Error signing up:", err.message);
        }
    };

    return (
        <div className='home-container'>
            <h1>Sign Up</h1>
            {error && <p className='form-error'>{error}</p>}
            <form onSubmit={handleSignup} className='auth-form'>
                <input type="email" value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder='Email'
                required 
                className='auth-input'/>
                <input type="password" value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder='Password'
                required 
                className='auth-input'/>
                <button type='submit' className='home-button'>Submit</button>
            </form>
            <p className='auth-link'>
                Already on the guild's roster? <Link to="/login">Log In</Link>
            </p>
        </div>
    );
}

export default Signup;